<template>
  <div>
<v-dialog v-model="dialog_errores"
                  persistent
                  width="400"
        >
            <v-card class="justify-center">
                <v-card-title
                        :class="head_color"
                        primary-title
                >
                    {{$t('aviso')}}
                    <v-spacer></v-spacer>
                    <v-chip v-if="errorCountdown > 0" label outline small color="white">
                        <v-icon left small>timer</v-icon>
                        {{ errorCountdown }}s
                    </v-chip>
                </v-card-title>
                <v-card-text>
                    <h3 class="text-xs-center">{{errores_guard}}</h3>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="justify-center">
                    <v-btn
                            v-if="band_gafete"
                            color="primary"
                            x-small
                            :loading="loading_gafete"
                            @click="download_gafete"
                    >{{$t('print_name_tag')}}
                    </v-btn>
                    <v-btn
                            color="primary"
                            @click="closeModal"
                    >
                        {{$t('aceptar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
<v-dialog v-model="dialog" persistent scrollable max-width="1000px">
            <v-card v-if="entrada" class="premium-card overflow-hidden">
                <v-toolbar dark color="primary">
                    <v-icon large class="mr-3">local_parking</v-icon>
                    <v-toolbar-title class="headline font-weight-bold">{{$t('info_invitation')}}</v-toolbar-title>
                    
                    <!-- Chip para tipo de código -->
                    <v-chip 
                        v-if="codeType"
                        label
                        class="mx-2"
                        :color="codeType === 'reservation' ? 'blue' : 'green'"
                        text-color="white"
                        small
                    >
                        <v-icon left x-small>
                            {{ codeType === 'reservation' ? 'event' : 'card_giftcard' }}
                        </v-icon>
                        {{ codeType === 'reservation' ? 'Código Reserva' : 'Invitación' }}
                    </v-chip>
                    
                    <v-spacer></v-spacer>
                    <v-chip v-if="countdown > 0" color="white" outline label class="mr-2">
                        <v-icon left>timer</v-icon>
                        {{ countdown }}s
                    </v-chip>
                    <v-btn
                            color="white"
                            flat
                            icon
                            @click="closeModal">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-card-text v-if="info_invitation" :class="['pa-0', info_invitation.available_spaces && info_invitation.available_spaces.length === 0 ? 'orange lighten-1' : '']">
                    <div v-if="info_invitation.available_spaces && info_invitation.available_spaces.length === 0" class="orange darken-3 white--text text-xs-center pa-3 mb-0 elevation-2">
                        <v-icon left dark large>warning</v-icon>
                        <span class="display-1 font-weight-bold uppercase">
                            {{ $t('no_spaces_available') }}
                        </span>
                    </div>

                    <!-- Status Banner -->
                    <!-- <div :class="!info_invitation.authorized ? 'banner-unauthorized' : 'banner-authorized'" class="text-xs-center pa-2 mb-4">
                        <v-icon left dark>{{ info_invitation.authorized ? 'error' : 'check_circle' }}</v-icon>
                        <span class="subheading font-weight-bold uppercase">
                            {{ info_invitation.authorized ? $t('not_authorized') : $t('authorized') }}
                        </span>
                    </div> -->

                    <v-container grid-list-md>
                        <v-layout row wrap>
                            <!-- Guest Section -->
                            <v-flex xs12 md6>
                                <v-card flat class="blue-grey lighten-5 rounded-card pa-3 mb-3">
                                    <!-- Avatar (solo usuarios con foto de perfil) -->
                                    <div v-if="info_invitation.guest_avatar" class="d-flex align-center justify-center mb-3">
                                        <v-avatar size="100" class="elevation-4">
                                            <v-img :src="info_invitation.guest_avatar"></v-img>
                                        </v-avatar>
                                    </div>
                                    <h3 class="title primary--text text-xs-center mb-4">{{$t('info_invitado')}}</h3>

                                    <v-list class="transparent" dense>
                                        <v-list-tile>
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title class="caption blue-grey--text">{{$t('Visitante')}}</v-list-tile-sub-title>
                                                <v-list-tile-title class="font-weight-bold">{{ info_invitation.guest_first_name }} {{ info_invitation.guest_last_name }}</v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-icon small color="blue-grey">person</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>

                                        <v-list-tile v-if="info_invitation.guest_phone">
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title class="caption blue-grey--text">{{$t('celular')}}</v-list-tile-sub-title>
                                                <v-list-tile-title>{{ info_invitation.guest_phone }}</v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-icon small color="blue-grey">phone_iphone</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>

                                        <!-- Placas (proveedor externo) -->
                                        <v-list-tile v-if="info_invitation.guest_plates">
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title class="caption blue-grey--text">Placas</v-list-tile-sub-title>
                                                <v-list-tile-title class="font-weight-bold">{{ info_invitation.guest_plates }}</v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-icon small color="blue-grey">directions_car</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>

                                        <!-- Unidad/modelo (proveedor externo) -->
                                        <v-list-tile v-if="info_invitation.guest_unit_specs">
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title class="caption blue-grey--text">Unidad</v-list-tile-sub-title>
                                                <v-list-tile-title>{{ info_invitation.guest_unit_specs }}</v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-icon small color="blue-grey">local_shipping</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                        
                                        <!-- INE Provider (proveedor externo) -->
                                        <v-list-tile v-if="info_invitation.provider_ine">
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title class="caption blue-grey--text">INE</v-list-tile-sub-title>
                                                <v-list-tile-title class="font-weight-bold">{{ info_invitation.provider_ine }}</v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-icon small color="blue-grey">card_membership</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>

                                        <!-- Foto INE grande (proveedor externo: tiene guest_id_front pero no guest_avatar) -->
                                        <v-list-tile v-if="info_invitation.guest_id_front && !info_invitation.guest_avatar">
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title class="caption blue-grey--text">Identificación (INE)</v-list-tile-sub-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                    </v-list>

                                    <!-- INE fuera del v-list para evitar recorte de v-list-tile -->
                                    <v-card v-if="info_invitation.guest_id_front && !info_invitation.guest_avatar" flat class="ine-card mt-2 mb-2">
                                        <v-img
                                            :src="info_invitation.guest_id_front"
                                            aspect-ratio="1.586"
                                            contain
                                            class="ine-img"
                                        ></v-img>
                                    </v-card>

                                    <v-list v-if="info_invitation.subject || info_invitation.expiration" class="transparent" dense>
                                        <v-list-tile>
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title class="caption blue-grey--text">{{$t('Asunto')}}</v-list-tile-sub-title>
                                                <v-list-tile-title>{{ info_invitation.subject }}</v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-icon small color="blue-grey">notes</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>

                                        <v-list-tile v-if="info_invitation.expiration">
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title class="caption blue-grey--text">{{$t('validity')}}</v-list-tile-sub-title>
                                                <v-list-tile-title>{{ info_invitation.invitation_date.split('-').join('/') }} - {{ info_invitation.expiration.split('-').join('/') }}</v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-icon small color="primary">event</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>

                                        <v-list-tile>
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title class="caption blue-grey--text">Horario</v-list-tile-sub-title>
                                                <v-list-tile-title>{{ formatInvitationTimeRange(info_invitation) }}</v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-icon small color="primary">schedule</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                    </v-list>
                                </v-card>
                            </v-flex>

                            <!-- Host Section -->
                            <v-flex xs12 md6>
                                <v-card flat class="blue-grey lighten-5 rounded-card pa-3 mb-3">
                                    <!-- Company Logo -->
                                    <div v-if="info_invitation.company_logo" class="d-flex align-center justify-center mb-3">
                                        <v-img 
                                            :src="info_invitation.company_logo" 
                                            max-width="120"
                                            max-height="120"
                                            contain
                                            class="elevation-2"
                                        ></v-img>
                                    </div>
                                    
                                    <!-- Host Avatar si no hay logo -->
                                    <div v-else-if="info_invitation.host_avatar" class="d-flex align-center justify-center mb-3">
                                        <v-avatar size="100" class="elevation-4">
                                            <v-img :src="info_invitation.host_avatar"></v-img>
                                        </v-avatar>
                                    </div>
                                    
                                    <h3 class="title primary--text text-xs-center mb-4">{{$t('info_anfitrion')}}</h3>
                                    
                                    <v-list class="transparent" dense>
                                        <!-- Company Information -->
                                        <v-list-tile v-if="info_invitation.company_name">
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title class="caption blue-grey--text">Empresa</v-list-tile-sub-title>
                                                <v-list-tile-title class="font-weight-bold">{{ info_invitation.company_name }}</v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-icon small color="blue-grey">business</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                        
                                        <!-- Host Person Information -->
                                        <v-list-tile>
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title class="caption blue-grey--text">{{$t('Anfitrion')}}</v-list-tile-sub-title>
                                                <v-list-tile-title class="font-weight-bold">{{ info_invitation.host_first_name }} {{ info_invitation.host_last_name }}</v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-icon small color="blue-grey">person</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>

                                        <v-list-tile v-if="info_invitation.host_phone">
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title class="caption blue-grey--text">{{$t('celular')}}</v-list-tile-sub-title>
                                                <v-list-tile-title>{{ info_invitation.host_phone }}</v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-icon small color="blue-grey">phone_iphone</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                        
                                        <!-- Section Info -->
                                        <v-list-tile v-if="info_invitation.section_name">
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title class="caption blue-grey--text">Sección</v-list-tile-sub-title>
                                                <v-list-tile-title>{{ info_invitation.section_name }}</v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-icon small color="blue-grey">location_on</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                    </v-list>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="pa-4 bg-muted">
                    <v-layout align-center justify-center row wrap>
                        <!-- <v-flex v-if="!info_invitation.authorized" xs12 class="text-xs-center mb-3">
                            <v-chip color="amber lighten-4" class="font-weight-bold">
                                <v-icon left>warning</v-icon>
                                {{$t('attemps')}}: {{info_invitation.count}}/2
                            </v-chip>
                        </v-flex> -->
                        <v-flex xs12 class="text-xs-center d-flex justify-center flex-wrap">
                            <v-btn
                                    large
                                    depressed
                                    class="rounded-btn mx-2 my-1"
                                    color="primary"
                                    @click="closeModal"
                            >
                                <v-icon left>close</v-icon>
                                {{ $t('cerrar')}}
                            </v-btn>
                            
                            <!-- <v-btn
                                    v-if="!info_invitation.authorized"
                                    large
                                    :disabled="info_invitation.available_spaces.length === 0"
                                    depressed
                                    class="rounded-btn mx-2 my-1 premium-btn-success"
                                    color="success"
                                    :loading="loading"
                                    @click="create_acceso(info_invitation.id)"
                            >
                                <v-icon left>vpn_key</v-icon>
                                {{$t('registrar_entrada')}}
                            </v-btn> -->
                            
                            <!-- <v-btn
                                    v-if="!info_invitation.authorized && info_invitation.count !== 0"
                                    large
                                    depressed
                                    class="rounded-btn mx-2 my-1"
                                    color="primary"
                                    :loading="loading"
                                    @click="notificar_anfitrion_acceso()"
                            >
                                <v-icon left>notifications_active</v-icon>
                                Notificar Autorización
                            </v-btn> -->
<!--                             
                            <v-btn
                                    v-if="!info_invitation.authorized && info_invitation.count === 0"
                                    large
                                    depressed
                                    class="rounded-btn mx-2 my-1 premium-btn-success"
                                    color="success"
                                    :loading="loading"
                                    @click="create_acceso(info_invitation.id), dialog = false, qr_code='', entrada = false, salida = false, activar_camara = true"
                            >
                                <v-icon left>vpn_key</v-icon>
                                {{$t('acceso')}}
                            </v-btn> -->
<!--                             
                            <v-btn
                                    v-if="!info_invitation.authorized && info_invitation.count !== 0"
                                    fab
                                    small
                                    depressed
                                    class="mx-2 my-1"
                                    color="primary"
                                    :loading="loadingCountIn"
                                    @click="updateCountEntrada()"
                                >
                                <v-icon>refresh</v-icon>
                            </v-btn> -->
                        </v-flex>
                    </v-layout>
                </v-card-actions>
            </v-card>

            <!-- CARD SALIDA -->
            <v-card v-if="salida" class="premium-card overflow-hidden">
                <v-toolbar dark color="primary">
                    <v-icon large class="mr-3">exit_to_app</v-icon>
                    <v-toolbar-title class="headline font-weight-bold">{{$t('form_salida')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-chip v-if="countdown > 0" color="white" outline label class="mr-2">
                        <v-icon left>timer</v-icon>
                        {{ countdown }}s
                    </v-chip>
                    <v-btn
                            color="white"
                            flat
                            icon
                            @click="closeModal">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>

                <v-card-text v-if="Object.keys(info_invitation).length > 0" class="pa-0">
                    <!-- Status Banner -->
                    <!-- <div :class="data_access[0].pase_salida ? 'banner-authorized' : 'banner-unauthorized'" class="text-xs-center pa-2 mb-4">
                        <v-icon left dark>{{ data_access[0].pase_salida ? 'check_circle' : 'warning' }}</v-icon>
                        <span class="subheading font-weight-bold uppercase">
                            {{ data_access[0].pase_salida ? 'Salida Autorizada' : 'Pase de Salida Pendiente' }}
                        </span>
                    </div> -->

                    <v-container grid-list-md>
                        <v-layout row wrap>
                             <!-- Guest Section -->
                             <v-flex xs12 md6>
                                <v-card flat class="blue-grey lighten-5 rounded-card pa-3 mb-3">
                                    <div class="d-flex align-center mb-3">
                                        <!-- <v-avatar size="100" class="elevation-4 avatar-border mx-auto mb-3"> -->
                                            <v-img :src="info_invitation.guest_avatar || 'https://via.placeholder.com/100'"></v-img>
                                        <!-- </v-avatar> -->
                                    </div>
                                    <h3 class="title primary--text text-xs-center mb-4">{{$t('info_invitado')}}</h3>
                                    
                                    <v-list class="transparent" dense>
                                        <v-list-tile>
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title class="caption blue-grey--text">{{$t('Visitante')}}</v-list-tile-sub-title>
                                                <v-list-tile-title class="font-weight-bold">{{ info_invitation.guest_first_name }} {{ info_invitation.guest_last_name }}</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>

                                        <v-list-tile v-if="info_invitation.guest_phone">
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title class="caption blue-grey--text">{{$t('celular')}}</v-list-tile-sub-title>
                                                <v-list-tile-title>{{ info_invitation.guest_phone }}</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>

                                        <v-list-tile v-if="info_invitation.guest_name_company">
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title class="caption blue-grey--text">{{$t('Empresa')}}</v-list-tile-sub-title>
                                                <v-list-tile-title>{{ info_invitation.guestNameCompany }}</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                    </v-list>
                                </v-card>
                            </v-flex>

                            <!-- Access Info Section -->
                            <v-flex xs12 md6>
                                <v-card flat class="blue-grey lighten-5 rounded-card pa-3 mb-3">
                                    <h3 class="title primary--text text-xs-center mb-4">{{$t('info_acceso')}}</h3>
                                    
                                    <v-list class="transparent" dense>
                                        <v-list-tile>
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title class="caption blue-grey--text">{{$t('fecha_hora_acceso_in')}}</v-list-tile-sub-title>
                                                <v-list-tile-title>{{ data_access[0].access_time }}</v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-icon small color="success">login</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>

                                        <v-list-tile>
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title class="caption blue-grey--text">{{$t('estado')}}</v-list-tile-sub-title>
                                                <v-list-tile-title :class="data_access[0].access_type == 'ENTRY' ? 'green--text' : 'red--text'">
                                                    {{data_access[0].access_type == 'ENTRY' ? $t('adentro') : $t('afuera')}}
                                                </v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>

                                        <v-list-tile>
                                            <v-list-tile-content>
                                                <v-list-tile-sub-title class="caption blue-grey--text">{{$t('assigned_parking_space')}}</v-list-tile-sub-title>
                                                <v-list-tile-title :class="data_access[0].access_type == 'ENTRY' ? 'success--text font-weight-bold' : 'orange--text font-weight-bold'">
                                                    {{ data_access[0].number || data_access[0].space_number}}
                                                </v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-icon small :color="data_access[0].access_type == 'ENTRY'  ? 'success' : 'orange'">{{ data_access[0].access_type == 'ENTRY' ? 'assignment_turned_in' : 'assignment_late' }}</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                    </v-list>
                                </v-card>
                                
                                <!-- Host Info Section -->
                                <v-card flat class="blue-grey lighten-5 rounded-card pa-3">
                                    <v-layout row wrap align-center>
                                        <v-flex xs12 sm2 class="text-xs-center">
                                            <v-avatar size="60" class="elevation-2">
                                                <v-img :src="info_invitation.host_avatar || 'https://via.placeholder.com/60'"></v-img>
                                            </v-avatar>
                                        </v-flex>
                                        <v-flex xs12 sm5>
                                            <div class="caption blue-grey--text">{{$t('Anfitrion')}}</div>
                                            <div class="subheading font-weight-bold">{{ info_invitation.host_first_name }} {{ info_invitation.host_last_name }}</div>
                                        </v-flex>
                                        <v-flex xs12 sm5 v-if="info_invitation.host_phone">
                                            <div class="caption blue-grey--text">{{$t('celular')}}</div>
                                            <div class="subheading">{{ info_invitation.host_phone }}</div>
                                        </v-flex>
                                    </v-layout>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="pa-4 bg-muted">
                    <v-layout align-center justify-center row wrap>
                        <!-- <v-flex v-if="!data_access[0].pase_salida" xs12 class="text-xs-center mb-3">
                            <v-chip color="amber lighten-4" class="font-weight-bold">
                                <v-icon left>warning</v-icon>
                                {{$t('attemps')}}: {{data_access[0].count}}/2
                            </v-chip>
                        </v-flex> -->
                        <v-flex xs12 class="text-xs-center d-flex justify-center flex-wrap">
                            <v-btn
                                    large
                                    depressed
                                    class="rounded-btn mx-2 my-1"
                                    color="primary"
                                    @click="closeModal"
                            >
                                <v-icon left>close</v-icon>
                                {{ $t('cerrar')}}
                            </v-btn>
                            
                            <!-- <v-btn
                                    large
                                    depressed
                                    class="rounded-btn mx-2 my-1 premium-btn-success"
                                    color="success"
                                    :loading="loading"
                                    @click="update_acceso(data_access[0].id), activar_camara = true"
                            >
                                <v-icon left>logout</v-icon>
                                {{$t('registrar_salida')}}
                            </v-btn> -->
                            
                            <!-- <v-btn
                                    v-if="!data_access[0].pase_salida && data_access[0].count !== 0"
                                    large
                                    depressed
                                    class="rounded-btn mx-2 my-1"
                                    color="primary"
                                    :loading="loading"
                                    @click="notificar_anfitrion_firmar()"
                            >
                                <v-icon left>notifications_active</v-icon>
                                Notificar Firma
                            </v-btn>
                             -->
                            <!-- <v-btn
                                    v-if="!data_access[0].pase_salida && data_access[0].count === 0"
                                    large
                                    depressed
                                    class="rounded-btn mx-2 my-1 premium-btn-success"
                                    color="success"
                                    :loading="loading"
                                    @click="update_acceso(data_access[0].id), activar_camara = true"
                            >
                                <v-icon left>logout</v-icon>
                                {{$t('registrar_salida')}}
                            </v-btn> -->
                            
                            <!-- <v-btn
                                    v-if="!data_access[0].pase_salida && data_access[0].count !== 0"
                                    fab
                                    small
                                    depressed
                                    class="mx-2 my-1"
                                    color="primary"
                                    :loading="loadingCount"
                                    @click="updateCount()"
                                >
                                <v-icon>refresh</v-icon>
                            </v-btn> -->
                        </v-flex>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog>
  </div>
</template>

<script>
    import { QrcodeStream } from 'vue-qrcode-reader'
    import store from '@/store'
    import { mapState, mapGetters } from 'vuex'
    import jsPDF from 'jspdf'
    import axios from 'axios'
    import { handleApiError, handleApiErrorInModal } from '@/utils/errorHandler'
    
    export default {
        name: "AccessParkingModal",
        components: {
            QrcodeStream
        },
                props: {
            qr_code: {
                type: String,
                required: true
            }
        },
        data () {
            return {
                
                error: '',
                info_invitation: [],
                dialog: false,
                valido: false,
                id_vigilante: 0,
                salida: false,
                entrada: false,
                estado: '',
                motivo_no_firma: '',
                comentarios_VE: '',
                errores: [],
                datos_coche: '',
                equipo_por_invitacion: [],
                data_access: [],
                dialog_inicio: false,
                casetas: [],
                caseta: 0,
                activar_camara: true,
                loading_gafete: false,
                
                // Nuevas propiedades para códigos de reserva
                codeType: null,
                isReservationCode: false,
                reservationCodeData: {},
                a_qr_code: '',
                internalQrCode: '',
                dialog_errores: false,
                errores_guard: '',
                head_color: '',
                band_gafete: false,
                dialogIP: false,
                ip: '127.0.0.1',
                loading: false,
                loadingCount: false,
                loadingCountIn: false,
                available_spaces: [],
                countdown: 0,
                autoEntryTimer: null,
                errorTimer: null,
                errorCountdown: 0,
                errorInterval: null
            }
        },
        created: function(){
            this.get_casetas()
            if(localStorage.getItem('id_caseta') === null){
                this.dialog_inicio = true
            }
            if(localStorage.getItem('dirIP') === null){
                this.ip = "127.0.0.1"
            } else {
                this.ip = localStorage.getItem('dirIP')
            }
        },
        computed: {
            ...mapGetters(['getProfile']),
            ...mapState(['caseta_vigilante']),
            ...mapState('parking_reservations', ['codes']),
            isParkingEnabled() {
                return this.getProfile && this.getProfile.enable_parking === true
            }
        },
        watch: {
            qr_code(val) {
                this.internalQrCode = val || ''
                if (this.internalQrCode) {
                    this.get_invitation()
                }
            },
            dialog_errores(val) {
                if (val) {
                    if (this.errorTimer) clearTimeout(this.errorTimer);
                    if (this.errorInterval) clearInterval(this.errorInterval);
                    this.errorCountdown = 10;
                    this.errorInterval = setInterval(() => {
                        this.errorCountdown--;
                    }, 1000);

                    this.errorTimer = setTimeout(() => {
                        this.closeModal();
                    }, 10000);
                } else {
                    if (this.errorTimer) {
                        clearTimeout(this.errorTimer);
                        this.errorTimer = null;
                    }
                    if (this.errorInterval) {
                        clearInterval(this.errorInterval);
                        this.errorInterval = null;
                    }
                    this.errorCountdown = 0;
                    this.errores_guard = '';
                    this.activar_camara = true;
                    this.band_gafete = false;
                }
            }
        },
                mounted() {
            this.internalQrCode = this.qr_code || ''
            if (this.internalQrCode) {
                this.get_invitation()
            }
        },
        methods: {
            closeModal() {
                this.clear_timer();
                this.dialog = false;
                this.dialog_errores = false;
                this.activar_camara = true;
                this.internalQrCode = '';
                this.a_qr_code = '';
                this.errores_guard = '';
                this.band_gafete = false;
                this.$emit('close');
            },
            get_local_today: function() {
                var today = new Date()
                var dd = today.getDate()
                var mm = today.getMonth() + 1
                var yyyy = today.getFullYear()
                if (dd < 10) dd = '0' + dd
                if (mm < 10) mm = '0' + mm
                return yyyy + '-' + mm + '-' + dd
            },
            validate_invitation_dates: function(info) {
                const today = this.get_local_today()
                const now = new Date()
                const nowMinutes = (now.getHours() * 60) + now.getMinutes()
                const toIso = (dateStr) => {
                    if (!dateStr) return null
                    const p = dateStr.split('-')
                    if (p.length !== 3 || p[0].length === 4) return dateStr
                    return `${p[2]}-${p[1]}-${p[0]}`
                }
                const toMinutes = (timeStr) => {
                    if (!timeStr || typeof timeStr !== 'string') return null
                    const parts = timeStr.split(':')
                    if (parts.length < 2) return null
                    const h = parseInt(parts[0], 10)
                    const m = parseInt(parts[1], 10)
                    if (Number.isNaN(h) || Number.isNaN(m)) return null
                    return (h * 60) + m
                }

                const startDate = toIso(info.invitation_date)
                const endDate = toIso(info.expiration)
                const startTime = toMinutes(info.start_time)
                const endTime = toMinutes(info.end_time)

                if (startDate && today < startDate) {
                    this.errores_guard = this.$t('mensaje_qr_no_vigente') + ' ' + this.$t('Fecha_ini') + ': ' + info.invitation_date
                    return false
                }
                if (endDate && today > endDate) {
                    this.errores_guard = this.$t('mensaje_qr_expirado') + ' ' + this.$t('Fecha_fin') + ': ' + info.expiration
                    return false
                }

                if ((startTime !== null || endTime !== null) && startDate && endDate && today >= startDate && today <= endDate) {
                    if (startTime !== null && nowMinutes < startTime) {
                        this.errores_guard = 'La invitacion aun no esta vigente por horario.'
                        return false
                    }
                    if (endTime !== null && nowMinutes > endTime) {
                        this.errores_guard = 'La invitacion expiro por horario.'
                        return false
                    }
                }
                return true
            },
            normalizeApiTime: function(timeStr) {
                if (!timeStr || typeof timeStr !== 'string') return ''
                return timeStr.split(':').slice(0, 2).join(':')
            },
            formatInvitationTimeRange: function(info) {
                const startTime = this.normalizeApiTime(info && info.start_time)
                const endTime = this.normalizeApiTime(info && info.end_time)
                if (startTime && endTime) return `${startTime} - ${endTime}`
                return startTime || endTime || 'Todo el dia'
            },
            get_current_date () {
              var today = new Date()
              var dd = today.getDate()
              var mm = today.getMonth() + 1
              var yyyy = today.getFullYear()

              if (dd < 10) {
                dd = '0' + dd
              }
              if (mm < 10) {
                mm = '0' + mm
              }
              today = mm + '/' + dd + '/' + yyyy
              return today
            },
            changeDirIP () {
                localStorage.setItem('dirIP', this.ip)
            },
            get_casetas: function(){
                this.$store.dispatch('security/FETCH_MY_CASETAS', store.getters.getToken)
                    .then(response => {
                        // Manejar múltiples formatos de respuesta
                        if (response && response.casetas && Array.isArray(response.casetas)) {
                            this.casetas = response.casetas
                        } else if (Array.isArray(response)) {
                            this.casetas = response
                        } else if (response && response.data && Array.isArray(response.data)) {
                            this.casetas = response.data
                        }
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            set_caseta: function(){
                if(this.caseta > 0){
                    localStorage.setItem('id_caseta', this.caseta)
                    this.dialog_inicio = false
                }
            },
            onDecode (result) {
                this.internalQrCode = result
                this.get_invitation()
            },
            get_invitation: async function(){
                if (this.internalQrCode !== '') {
                    this.available_spaces = null
                    this.loading = true
                    
                    try {
                        // Para Parking, TODOS los códigos se manejan como reservas
                        // Intentar obtener detalles del código de reserva
                        const config = {
                            method: 'get',
                            url: 'https://empresa-service.intrare.app/Parking/invitations/reservations/codes/?qr_code=' + this.internalQrCode,
                            headers: {
                                'Content-Type': 'application/json',
                                'authorization': 'Token ' + store.getters.getToken
                            }
                        }
                        
                        const response = await axios(config)
                        this.loading = false
                        
                        // Si no encuentra el código, mostrar error
                        if (!response.data || (Array.isArray(response.data) && response.data.length === 0)) {
                            this.valido = false
                            this.dialog = false
                            this.activar_camara = false
                            this.a_qr_code = ''
                            this.entrada = false
                            this.salida = false
                            this.errores_guard = this.$t('mensaje_qr_no_valido')
                            this.head_color = 'red display-1 text--primary'
                            this.dialog_errores = true
                            return
                        }
                        
                        // Obtener el código (si es array, tomar el primero)
                        const code = Array.isArray(response.data) ? response.data[0] : response.data
                        
                        // Tipo siempre es reserva
                        this.codeType = 'reservation'
                        this.isReservationCode = true
                        this.reservationCodeData = code
                        this.processReservationCode(code)
                        
                    } catch (error) {
                        this.valido = false
                        this.loading = false
                        this.clear_without_activate_camera()
                        this.errores_guard = this.$t('mensaje_qr_no_valido')
                        this.head_color = 'red display-1 text--primary'
                        this.dialog_errores = true
                        console.log(error)
                    }
                }
            },
            processReservationCode: function(code) {
                this.loading = false
                // Construir objeto info_invitation compatibe con el template actual
                this.info_invitation = {
                    id: code.id,
                    qr_code: code.qr_code,
                    guest_first_name: code.provider_name || 'Visitante',
                    guest_last_name: code.last_name || '',
                    guest_phone: code.contact_phone || '',
                    guest_email: code.contact_email || '',
                    guest_avatar: null,
                    available_spaces: [{
                        id: code.parking_space_id,
                        space_number: code.number || code.space_number,
                        number: code.number,
                        space_type_name: code.space_type_name,
                        parking_space_id: code.parking_space_id
                    }],
                    space_number: code.number || code.space_number,
                    automovil: true,
                    host_first_name: 'Empresa',
                    host_last_name: '',
                    host_phone: '',
                    host_avatar: null,
                    type: 'reservation',
                    reservation_id: code.reservation_id,
                    code_id: code.id,
                    subject: code.subject || ''
                }
                
                this.valido = true
                this.is_access_in_out_both()
            },
            registerAccessWithReservationCode: function(accessType = 'entry') {
                this.loading = true
                
                // Asegurar que siempre hay un parking_space_id válido
                // Prioridad: available_spaces (selección manual) > info_invitation.parking_space_id (de qr_info) > available_spaces array
                let parkingSpaceId = this.available_spaces || this.info_invitation.parking_space_id
                if (!parkingSpaceId && this.info_invitation.available_spaces && this.info_invitation.available_spaces.length > 0) {
                    parkingSpaceId = this.info_invitation.available_spaces[0].parking_space_id
                }
                
                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/Parking/invitations/parking-access/create/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        reservation_code_id: this.reservationCodeData.id,
                        qr_code: this.internalQrCode,
                        access_type: accessType,
                        parking_space_id: parkingSpaceId
                    }
                }
                
                axios(config)
                    .then(response => {
                        this.loading = false
                        const message = accessType === 'entry' 
                            ? this.$t('mensaje_alta_acceso_in')
                            : 'Salida registrada con éxito'
                        
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', message)
                        
                        // Esperar 3 segundos para que el usuario vea el snackbar
                        setTimeout(() => {
                            this.dialog = false
                            setTimeout(this.closeModal, 500)
                        }, 3000)
                    })
                    .catch(error => {
                        this.loading = false
                        // Mostrar en modal de error con mensaje extraído de la API
                        handleApiErrorInModal(error, this)
                    })
            },
            get_invitation_manual: function(){
                this.available_spaces = null
                this.loading = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/Parking/invitations/guard/qr/' + this.a_qr_code + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.loading = false
                        this.info_invitation = response.data
                        if (!this.info_invitation.arrival_registered && !this.validate_invitation_dates(this.info_invitation)) {
                            this.valido = false
                            this.dialog = false
                            this.activar_camara = false
                            this.a_qr_code = ''
                            this.entrada = false
                            this.salida = false
                            this.head_color = 'red display-1 text--primary'
                            this.dialog_errores = true
                            return
                        }
                        this.valido = true
                        this.is_access_in_out_both()
                    })
                    .catch(error => {
                        this.valido = false
                        this.loading = false
                        this.clear_without_activate_camera()
                        this.errores_guard =this.$t('mensaje_qr_no_valido')
                        this.head_color = 'red display-1 text--primary'
                        this.dialog_errores = true
                        console.log(error)
                    })

            },
            qr_is_valid: function(info_invitation){
                console.log(Object.keys(info_invitation).length)
                if (Object.keys(info_invitation).length > 0) {
                    this.valido = true
                    console.log("Valido")
                    this.is_access_in_out_both()
                }
                else{
                    this.valido = false
                    console.log("NO Valido")
                    //     this.$store.commit('snackbar_activate_true')
                    //     this.$store.commit('snackbar_change_color', 'error')
                    //     this.$store.commit('snackbar_change_message', this.$t('mensaje_qr_no_valido'))
                    //     setTimeout(this.clear, 3000)
                    this.clear_without_activate_camera()
                    this.errores_guard =this.$t('mensaje_qr_no_valido')
                    this.head_color = 'red display-1 text--primary'
                    this.dialog_errores = true
                }
            },
            is_access_in_out_both: function(){
                if(this.a_qr_code.length > 10)
                    this.internalQrCode = this.a_qr_code
                    const config = {
                        method: 'get',
                        url: 'https://empresa-service.intrare.app/Parking/invitations/history/',
                        headers: {
                            'Content-Type': 'application/json',
                            'authorization': 'Token ' + store.getters.getToken
                        },
                        params: {
                            qr_code: this.internalQrCode
                        }
                    };
                    axios(config)
                        .then(response => {
                            console.log(response.data)
                            // El endpoint retorna directamente entrada/salida
                            this.entrada = response.data.entrada
                            this.salida = response.data.salida
                            this.data_access = response.data.history || []
                            
                            // Obtener información completa desde qr_info
                            const qrInfo = response.data.qr_info || {}
                            
                            // Determinar parking_space_id desde available_spaces
                            let parkingSpaceId = null
                            if (qrInfo.available_spaces && qrInfo.available_spaces.length > 0) {
                                parkingSpaceId = qrInfo.available_spaces[0].parking_space_id
                            }
                            
                            // Enriquecer info_invitation con datos completos de qr_info + history
                            const providerData = this.data_access.length > 0 ? this.data_access[0] : {}
                            
                            this.info_invitation = {
                                ...this.info_invitation,
                                // Información del invitado/transportista - Usar qr_info como base, enriquecer con history si existe
                                guest_first_name: providerData.provider_first_name || qrInfo.guest_first_name || 'Visitante',
                                guest_last_name: providerData.provider_last_name || qrInfo.guest_last_name || '',
                                guest_phone: providerData.provider_phone || qrInfo.guest_phone || '',
                                guest_email: providerData.provider_email || qrInfo.guest_email || '',
                                guest_avatar: qrInfo.guest_avatar,
                                guest_id_front: qrInfo.guest_id_front,
                                guest_id_back: qrInfo.guest_id_back,
                                guest_plates: providerData.provider_plates || qrInfo.guest_plates || '',
                                guest_unit_specs: providerData.provider_unit_specs || qrInfo.guest_unit_specs || '',
                                provider_ine: providerData.provider_ine || qrInfo.provider_ine,
                                provider_id: providerData.provider_id || qrInfo.guest_id,
                                
                                // Información del espacio
                                space_number: qrInfo.space_number || this.info_invitation.space_number,
                                parking_space_id: parkingSpaceId,
                                section_name: qrInfo.section_name,
                                
                                // Información del anfitrión/empresa
                                host_first_name: qrInfo.host_first_name || 'Empresa',
                                host_last_name: qrInfo.host_last_name || '',
                                host_phone: qrInfo.host_phone || '',
                                host_avatar: qrInfo.host_avatar,
                                company_name: qrInfo.company_name || '',
                                company_logo: qrInfo.company_logo,
                                
                                // Información de la invitación/acceso
                                subject: qrInfo.subject || '',
                                invitation_date: qrInfo.invitation_date,
                                expiration: qrInfo.expiration,
                                notes: qrInfo.notes,
                                qr_status: qrInfo.qr_status,
                                access_count: qrInfo.access_count,
                                arrival_registered: qrInfo.arrival_registered,
                                has_assigned_space: qrInfo.has_assigned_space,
                                vehicle_type_name: qrInfo.vehicle_type_name,
                                
                                // Mantener available_spaces para compatibilidad
                                available_spaces: qrInfo.available_spaces || []
                            }
                            
                            this.dialog = true
                            this.activar_camara = false
                            console.log(response.data.message)
                            this.autoRegisterAccess()
                        })
                        .catch(error => {
                            console.log(error)
                        })
            },
             autoRegisterAccess: function() {
                 if (this.autoEntryTimer) clearInterval(this.autoEntryTimer);
                 if (this.entrada && (!this.info_invitation.available_spaces || this.info_invitation.available_spaces.length === 0)) {
                     this.countdown = 0;
                     return;
                 }

                 this.countdown = 10;
                 this.autoEntryTimer = setInterval(() => {
                     this.countdown--;
                     if (this.countdown <= 0) {
                         clearInterval(this.autoEntryTimer);
                         this.autoEntryTimer = null;
                         if (this.entrada && !this.info_invitation.authorized && this.info_invitation.available_spaces && this.info_invitation.available_spaces.length > 0) {
                             const randomIndex = Math.floor(Math.random() * this.info_invitation.available_spaces.length);
                             this.available_spaces = this.info_invitation.available_spaces[randomIndex].parking_space_id;
                             this.create_acceso(this.info_invitation.id);
                         } else if (this.salida) {
                             this.update_acceso(this.data_access[0].id);
                         }
                     }
                 }, 1000);
             },
            create_acceso: function(id_invitacion){
                // Si enable_parking está activo, solo mostrar visualización sin guardar
                if (this.isParkingEnabled) {
                    this.errores_guard = 'Modo Visualización: Solo se permite ver la información. No se guardará el acceso.'
                    this.head_color = 'blue lighten-1 white--text'
                    this.dialog_errores = true
                    return
                }
                // Parking: TODOS los códigos se manejan como reservas
                this.registerAccessWithReservationCode('entry')
            },
            sendDataWebServer (qrCode) {
                const config = {
                    method: 'post',
                    url: 'http://' + localStorage.getItem('dirIP') + '/set_data',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: {
                        qr_code: qrCode,
                        area: this.info_invitation.areaName
                    }
                }
                axios(config)
                    .then(response => {
                        console.log('Datos enviados al Web Server Correctamente.')
                        console.log(response)
                    })
                    .catch(error => {
                        console.log('Error del Web Server.')
                        console.log(error.response.data)
                    })
            },
            update_acceso (pk){
                // Si enable_parking está activo, solo mostrar visualización sin guardar
                if (this.isParkingEnabled) {
                    this.errores_guard = 'Modo Visualización: Solo se permite ver la información. No se guardará la salida.'
                    this.head_color = 'blue lighten-1 white--text'
                    this.dialog_errores = true
                    return
                }
                // Parking: TODOS los códigos se manejan como reservas
                this.registerAccessWithReservationCode('exit')
            },
            updateCount () {
                this.loadingCount = true
                const config2 = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/empresas/accesos/search/' + this.internalQrCode + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                }
                axios(config2)
                    .then(response2 => {
                        if (this.info_invitation.typeInv !== 2)
                            this.data_access = response2.data
                        else
                          if (response2.data.length > 1) {
                            this.data_access = response2.data
                            console.log('Datos Accesos Count = ', response2.data[0])
                            }
                          else
                            this.data_access = response2.data
                        this.loadingCount = false
                    })
                    .catch(error => {
                        this.loadingCount = false
                        console.log(error)
                    })
            },
            updateCountEntrada () {
                this.loadingCountIn = true
                const config2 = {
                    method: 'get',
                    url:  'https://empresa-service.intrare.app/get_inv/gaurd/' + this.internalQrCode + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                }
                axios(config2)
                    .then(response2 => {
                        if (this.info_invitation.typeInv !== 2)
                            this.info_invitation = response2.data
                        else
                          if (response2.data.length > 1) {
                            this.info_invitation = response2.data
                            console.log('Datos Invitacion Count = ', response2.data[0])
                            }
                          else
                            this.info_invitation = response2.data
                        this.loadingCountIn = false
                    })
                    .catch(error => {
                        this.loadingCountIn = false
                        console.log(error)
                    })
            },
            notificar_anfitrion_firmar(){
                this.loading = true
                console.log('Avisar al Anfitrión que firme pase de Salida = ', this.data_access[0].id)
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/notifySignExitPass/' + this.data_access[0].id + '/',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                };
                axios(config)
                    .then(response => {
                        this.loading = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('msg_notificacion_anfitrion'))
                        const config2 = {
                            method: 'get',
                            url: 'https://empresa-service.intrare.app/empresas/accesos/search/' + this.internalQrCode + '/',
                            headers: {
                                'Content-Type': 'application/json',
                                'authorization': 'Token ' + store.getters.getToken
                            }
                        }
                        axios(config2)
                            .then(response2 => {
                                console.log(response2.data)
                                if (this.info_invitation.typeInv !== 2)
                                    this.data_access = response2.data
                                else
                                  if (response2.data.length > 1) {
                                    console.log('Datos de acceso despues de notificar al Antitrion = ,', response2.data[0])
                                    this.data_access = response2.data
                                  }
                                  else
                                    this.data_access = response2.data
                            })
                            .catch(error => {
                                console.log(error)
                            })
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error)
                    })
            },
            notificar_anfitrion_acceso(){
                this.loading = true
                console.log('Avisar al Anfitrión que autorize el acceso de su invitado= ', this.info_invitation.id)
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/notifyAuthorizedAccess/' + this.info_invitation.id + '/',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                };
                axios(config)
                    .then(response => {
                        this.loading = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('msg_notificacion_anfitrion'))
                        const config2 = {
                            method: 'get',
                            url: 'https://empresa-service.intrare.app/get_inv/gaurd/' + this.internalQrCode + '/',
                            headers: {
                                'Content-Type': 'application/json',
                                'authorization': 'Token ' + store.getters.getToken
                            }
                        }
                        axios(config2)
                            .then(response2 => {
                                console.log(response2.data)
                                if (this.info_invitation.typeInv !== 2)
                                    this.info_invitation = response2.data
                                else
                                  if (response2.data.length > 1) {
                                    console.log('Datos de acceso despues de notificar al Antitrion = ,', response2.data[0])
                                    this.info_invitation = response2.data
                                  }
                                  else
                                    this.info_invitation = response2.data
                            })
                            .catch(error => {
                                console.log(error)
                            })
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error)
                    })
            },
            async onInit (promise) {
                try {
                    await promise
                } catch (error) {
                    if (error.name === 'NotAllowedError') {
                        this.error = "ERROR: you need to grant camera access permisson"
                    } else if (error.name === 'NotFoundError') {
                        this.error = "ERROR: no camera on this device"
                    } else if (error.name === 'NotSupportedError') {
                        this.error = "ERROR: secure context required (HTTPS, localhost)"
                    } else if (error.name === 'NotReadableError') {
                        this.error = "ERROR: is the camera already in use?"
                    } else if (error.name === 'OverconstrainedError') {
                        this.error = "ERROR: installed cameras are not suitable"
                    } else if (error.name === 'StreamApiNotSupportedError') {
                        this.error = "ERROR: Stream API is not supported in this browser"
                    }
                }
            },
            clear_timer: function() {
                if (this.autoEntryTimer) {
                    clearInterval(this.autoEntryTimer);
                    this.autoEntryTimer = null;
                }
                this.countdown = 0;
            },
            clear: function () {
                this.clear_timer()
                this.dialog = false
                this.internalQrCode = ''
                this.a_qr_code = ''
                this.entrada = false
                this.salida = false
                this.activar_camara = true
                this.$store.commit('snackbar_activate_false')
                this.$store.commit('snackbar_change_color', 'success')
            },
            clear_without_activate_camera: function () {
                this.clear_timer()
                this.dialog = false
                this.activar_camara = false
                this.internalQrCode = ''
                this.a_qr_code = ''
                this.entrada = false
                this.salida = false
            },
            get_equipo_invitacion: function(){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/equipo_seguridad/' + this.info_invitation.id + '/',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                };
                axios(config)
                    .then(response => {
                        this.equipo_por_invitacion = response.data
                        console.log(this.equipo_por_invitacion)
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            xOffset: function(pdf, text){
                return ((pdf.internal.pageSize.width / 2) - (pdf.getStringUnitWidth(text) * pdf.internal.getFontSize() / 2) / 72.0)
            },
            getImgFromUrl(logo_url, callback) {
                var img = new Image();
                img.src = logo_url;
                img.onload = function () {
                    callback(img);
                };
            },
            download_gafete_original: function(){
                this.loading_gafete = true
                console.log('Datos de la Invitación: ')
                console.log(this.info_invitation)
                // console.log(this.info_invitation)
                const toDataUrl = (url, callback) => {
                    const xhr = new XMLHttpRequest();
                    xhr.onload = () => {
                        const reader = new FileReader();
                        reader.onloadend = () => {
                            callback(reader.result);
                        };
                        reader.readAsDataURL(xhr.response);
                    };
                    xhr.open('GET', url);
                    xhr.responseType = 'blob';
                    xhr.send();
                };

                toDataUrl(this.info_invitation.avatar, (myBase64) => {
                    var pdf = new jsPDF("portrait", "pt", "letter")
                    // Black square with rounded corners
                    pdf.setDrawColor(0)
                    pdf.setFillColor(255, 255, 255)
                    pdf.roundedRect(180, 50, 250, 400, 5, 5, 'FD')
                    pdf.setFontStyle("bold")
                    pdf.text(this.info_invitation.empresa,
                        this.xOffset(pdf, this.info_invitation.empresa),
                        130)
                    pdf.setFontStyle("normal")
                    pdf.text(this.$t('Visitante'),
                        this.xOffset(pdf, this.$t('Visitante')),
                        145)
                    pdf.setFontStyle("bold")
                    pdf.text(this.info_invitation.guestFirstName + ' ' + this.info_invitation.guestLastName,
                        this.xOffset(pdf, this.info_invitation.guestFirstName + ' ' + this.info_invitation.guestLastName) ,
                        160)
                    pdf.setFontStyle("normal")
                    pdf.text(this.$t('Anfitrion'),
                        this.xOffset(pdf, this.$t('Anfitrion')),
                        175)
                    pdf.setFontStyle("bold")
                    pdf.text(this.info_invitation.hostFirstName + ' ' + this.info_invitation.hostLastName,
                        this.xOffset(pdf, this.info_invitation.hostFirstName + ' ' + this.info_invitation.hostLastName),
                        190)
                    pdf.setFontStyle("normal")
                    pdf.text(this.$t('Area'),
                        this.xOffset(pdf, this.$t('Area')),
                        205)
                    pdf.setTextColor(this.info_invitation.areaColor)
                    pdf.setFontStyle("bold")
                    pdf.text(this.info_invitation.areaName.toUpperCase(),
                        this.xOffset(pdf, this.info_invitation.areaName.toUpperCase()),
                        220)
                    pdf.setTextColor('#000000')
                    pdf.text(this.$t('fecha_hora'),
                        this.xOffset(pdf, this.$t('fecha_hora')),
                        235)
                    pdf.setFontStyle("normal")
                    pdf.text(this.info_invitation.dateInv + ' ' + this.info_invitation.timeInv,
                        this.xOffset(pdf, this.info_invitation.dateInv + ' ' +  this.info_invitation.timeInv),
                        250)
                    pdf.setLineWidth(4.0)
                    pdf.setDrawColor(this.info_invitation.areaColor)
                    pdf.setFillColor('#FFFFFF')
                    pdf.roundedRect(212, 257, 186, 186, 5, 5, 'FD')
                    // console.log(myBase64); // myBase64 is the base64 string
                    pdf.addImage(myBase64, 'WEBP', 215, 260, 180, 180);
                    toDataUrl(this.info_invitation.logoEmpresa, (logo_guest) => {
                        pdf.addImage(logo_guest, 'WEBP', 190, 60, 50, 50);
                        this.getImgFromUrl(require('../../assets/intrare_logo.png'), function (logo_system,) {
                            pdf.addImage(logo_system, 'WEBP', 370, 60, 50, 50);
                            pdf.save('gafete.pdf')
                        });
                    });
                    this.loading_gafete = false
                });
            },
            download_gafete: function(){
                this.loading_gafete = true
                console.log('Datos de la Invitación: ')
                console.log(this.info_invitation)
                // console.log(this.info_invitation)
                const toDataUrl = (url, callback) => {
                    const xhr = new XMLHttpRequest();
                    xhr.onload = () => {
                        const reader = new FileReader();
                        reader.onloadend = () => {
                            callback(reader.result);
                        };
                        reader.readAsDataURL(xhr.response);
                    };
                    xhr.open('GET', url);
                    xhr.responseType = 'blob';
                    xhr.send();
                };
                var pdf = new jsPDF('l', 'in', [288, 144])
                // Black square with rounded corners
                pdf.setDrawColor(0)
                pdf.setFontSize(9)
                pdf.text(this.$t('fecha_hora_acceso'),
                    2,
                    0.4)
                pdf.setLineWidth(0.02)
                pdf.line(2, 0.42, 3.4, 0.42)
                pdf.setFontStyle("normal")
                pdf.text(this.info_invitation.dateInv + ' ' + this.info_invitation.timeInv,
                    2.25,
                    0.6)
                pdf.setFontSize(14)
                // pdf.setFillColor(255, 255, 255)
                // pdf.roundedRect(180, 50, 250, 400, 5, 5, 'FD')
                // pdf.setFontStyle("bold")
                // pdf.text(this.info_invitation.empresa,
                //     this.xOffset(pdf, this.info_invitation.empresa),
                //     130)
                pdf.line(this.xOffset(pdf, this.$t('Visitante').toUpperCase()), 0.92, 2.5, 0.92)
                pdf.setFontStyle("normal")
                pdf.text(this.$t('Visitante').toUpperCase(),
                    this.xOffset(pdf, this.$t('Visitante').toUpperCase()),
                    0.9)
                pdf.setFontStyle("bold")
                pdf.text(this.info_invitation.guestFirstName + ' ' + this.info_invitation.guestLastName,
                    this.xOffset(pdf, this.info_invitation.guestFirstName + ' ' + this.info_invitation.guestLastName),
                    1.2)
                pdf.line(this.xOffset(pdf, this.$t('Anfitrion').toUpperCase()), 1.47, 2.5, 1.47)
                pdf.setFontStyle("normal")
                pdf.text(this.$t('Anfitrion').toUpperCase(),
                    this.xOffset(pdf, this.$t('Anfitrion').toUpperCase()),
                    1.45)
                pdf.setFontStyle("bold")
                pdf.text(this.info_invitation.hostFirstName + ' ' + this.info_invitation.hostLastName,
                    this.xOffset(pdf, this.info_invitation.hostFirstName + ' ' + this.info_invitation.hostLastName),
                    1.70)
                // pdf.setFontStyle("normal")
                // pdf.text(this.$t('Area'),
                //     this.xOffset(pdf, this.$t('Area')),
                //     205)
                // pdf.setTextColor(this.info_invitation.areaColor)
                // pdf.setFontStyle("bold")
                // pdf.text(this.info_invitation.areaName.toUpperCase(),
                //     this.xOffset(pdf, this.info_invitation.areaName.toUpperCase()),
                //     220)
                pdf.setTextColor('#000000')
                // pdf.setLineWidth(4.0)
                // pdf.setDrawColor(this.info_invitation.areaColor)
                // pdf.setFillColor('#FFFFFF')
                // pdf.roundedRect(212, 257, 186, 186, 5, 5, 'FD')
                // console.log(myBase64); // myBase64 is the base64 string
                // pdf.addImage(myBase64, 'WEBP', 215, 260, 180, 180);
                toDataUrl(this.info_invitation.logoEmpresa, (logo_guest) => {
                    pdf.addImage(logo_guest, 'WEBP', 0.25, 0.25, 0.8, 0.6);
                    pdf.save('gafete.pdf')
                    this.loading_gafete = false
                });
            }
        }
    }
</script>

<style scoped>
.ine-card {
    border-radius: 8px;
    overflow: hidden;
    width: 100%;
    background: #263238;
}
.ine-img {
    width: 100%;
    border-radius: 8px;
}
</style>
